import { PropType, computed, defineComponent, onUnmounted, ref, watch } from 'vue'
import { Store } from 'pinia'
import { clearHistory } from '../../router'
import { ChargeMapContext } from '../chargerMap/index.model'
import { ComponentActions, ComponentState } from '../../nsh5/localStores/component'
import { Point } from '../../contract/map'
import { flyTo, removeResourceCircle } from '../chargerMap/mapUtils'

/**
 * 全国小点渲染功能模块
 */
export default defineComponent({
  name: 'auto-refresh-view',
  props: {
    mapContextRef: {
      type: Object as PropType<ChargeMapContext>,
    },
    mapInstance: {
      type: Object,
    },
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
    mapSetting: {
      type: Object,
      default: {} as { [key: string]: any },
    },
  },
  emits: ['backHome'],
  setup: (props, { emit }) => {
    const mapContextRef = computed(() => props.mapContextRef)
    const mapInstance = computed(() => props.mapInstance)
    const zoomLevel = ref<number>(0)

    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig

    // 用于判断是否需要刷新地图资源
    const RUNNING_LOCAL =
      (window.location.host.split('.')[0].split('-').pop() || '').indexOf('localhost') !== -1
    // x分钟刷新回默认状态，分终端渠道时间可配，默认3分钟
    let refreshTimer: any

    // 启动自动刷新
    const refresher = () => {
      if (RUNNING_LOCAL || componentsConfig?.auto_zoom?.show) {
        // 本地开发不走自动刷新   auto_zoom开启也不走自动刷新
        return
      }
      if (componentsConfig?.refresh?.show && !refreshTimer) {
        refreshTimer = setTimeout(() => {
          props.componentStore.bus.emit('destroyCountyLayout')
          goBackHome()
          refresher()
        }, (componentsConfig?.refresh?.properties?.refresh_interval || 3) * 60 * 1000)
      }
    }

    props.componentStore.bus.on('goBackHome', (isCallBack = true) => {
      goBackHome(isCallBack)
    })

    props.componentStore.bus.on('interruptRefresher', () => {
      interruptRefresher()
    })

    /**
     * 回到首页
     */
    const goBackHome = (isCallBack = true) => {
      // debugger
      console.log('========goBackHome===========window.backHistoryNum=================')
      console.log(window.backHistoryNum)
      console.log('====================================')
      mapInstance.value?.clearOverlays() // 会有多个icon加载情况所以全部清除
      clearHistory()
      props.componentStore.bus.emit('clearAllMarkers') // 清空ICON
      props.componentStore.bus.emit('filterReset')
      props.componentStore.bus.emit('handleHomeSearchClear') // 清空搜索
      props.componentStore.bus.emit('forceClearBackList') // 清空后退列表
      props.componentStore.bus.emit(
        'onChangeHeightLevel',
        componentsConfig?.data_default?.show ? 1 : 0
      ) // dragPopup高度回到1
      // 关闭搜索态
      props.componentStore.$patch({
        showSearchPanel: false,
      })
      // 若筛选看板打开则关闭
      props.componentStore.filterPanel && props.componentStore.bus.emit('closeFilterPanel')
      // 若搜索看板打开则关闭
      props.componentStore.searchListPanel && props.componentStore.bus.emit('closeSearchListPanel')
      props.componentStore.triggerPanel()
      // router.go(-1)
      clearMapContent()
      const currentCenter = mapContextRef.value?.getCenter()
      if (
        (zoomLevel.value !== props.mapSetting.minZoom ||
          currentCenter?.lat != props.mapSetting.center.lat ||
          currentCenter?.lng != props.mapSetting.center.lng) &&
        props.mapSetting.center &&
        props.mapSetting.zoom
      ) {
        if (
          zoomLevel.value === 0 &&
          currentCenter?.lat == props.mapSetting.center.lat &&
          currentCenter?.lng == props.mapSetting.center.lng
        ) {
          // 因为zoomLevel层级为最小且中心点不变的情况下不会触发dotRender的zoomLevel改变，所以需要手动触发
          props.componentStore.bus.emit('showResourcesDotByFilter')
        } else {
          // 如果地图当前zoom不是最小层级，需要回到最小层级
          flyTo(mapContextRef.value!, props.mapSetting.center as Point, props.mapSetting.zoom)
        }
      } else if (zoomLevel.value === props.mapSetting.minZoom) {
        // 因为zoomLevel层级为最小的时候不会触发dotRender的zoomLevel改变，所以需要手动触发
        props.componentStore.bus.emit('showResourcesDotByFilter')
      }
      isCallBack && emit('backHome')
    }

    /**
     * 清除除小点外的其他内容
     */
    const clearMapContent = () => {
      mapContextRef.value?.removeMarkers() // 大ICON
      removeResourceCircle(mapContextRef.value!) // 电区房
      props.componentStore.bus.emit('clearLocationMarker') // 戳点pin
      props.componentStore.bus.emit('clearPositionMarker') // 定位点
    }

    // 打断自动刷新  点击/zoom
    const interruptRefresher = () => {
      props.componentStore.bus.emit('onPushStayDuration')
      refreshTimer && clearTimeout(refreshTimer)
      refreshTimer = null
      refresher()
    }
    // ------------暴露出去的方法--------------
    const zoomEnd = async () => {
      zoomLevel.value = mapInstance.value?.getZoom()
    }

    // 启动相关事件监听
    const initEventListener = () => {
      mapInstance.value?.addEventListener('zoomend', zoomEnd, false)
      mapInstance.value?.addEventListener('dragend', interruptRefresher, false)
      document.addEventListener('touchend', interruptRefresher)
      document.addEventListener('click', interruptRefresher)
    }

    // unmounted时摧毁相关事件监听
    // const destroyEventListener = () => {
    //   mapInstance.value.removeEventListener('zoomend', zoomEnd, false)
    //   mapInstance.value.removeEventListener('dragend', interruptRefresher, false)
    //   document.removeEventListener('touchend', interruptRefresher)
    //   document.removeEventListener('click', interruptRefresher)
    // }

    onUnmounted(() => {
      // destroyEventListener()
      props.componentStore.bus.off('goBackHome')
    })

    /**
     * 组件获取地图实例后的回调
     */
    const onReady = () => {
      // mapInstance.value = mapContextRef.value?.getMap()
      initEventListener()
      refresher()
    }
    watch(
      () => props.mapContextRef,
      () => {
        if (props.mapContextRef) {
          // mapContextRef.value = props.mapContextRef
          onReady()
        }
      }
    )
    return () => {}
  },
})
